import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';

import { SearchInput, StatusBullet } from 'components';
import { 
  Typography, 
  TextField, 
  MenuItem,
  Button,
  IconButton, 
} from '@material-ui/core';


import DateFnsUtils from '@date-io/date-fns';
import krLocale from "date-fns/locale/ko";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from '@material-ui/pickers';

import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';

//import { statusContracts } from 'common/datas';

//const find_item_contracts = [{value:-1, label: '전체'}, ...statusContracts];

const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    height: '62px',
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  rowIcons: {
    height: '62px',
    display: 'flex',
    alignItems: 'center',
    //paddingLeft: theme.spacing(8),
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  // row1: {
  //   width: '240px',
  //   display: 'flex',
  //   alignItems: 'center',
  //   marginLeft: theme.spacing(6),
  //   '& > *': {
  //     marginLeft: theme.spacing(0),
  //     margin: theme.spacing(1),
  //   },
  // },
  spacer: {
    flexGrow: 1
  },
  Button: {
    marginRight: theme.spacing(1)
  },
  exportButton: {
    marginRight: theme.spacing(1)
  },
  searchInput: {
    marginRight: theme.spacing(1)
  },
  registerListItemTitle: {
    marginLeft: theme.spacing(2),
    width: '100px',
  },
  registerListItemInput: {
    //marginLeft: theme.spacing(2),
    width: '240px',
    //height: '40px',
  },
}));

const ClientToolbar = props => {
  //const { className, ...rest } = props;

  const { 
    className, 
    onClickSearch,
    contracts,
    valueContract,
    onChangeContract, 
    ...rest
 } = props;

  const classes = useStyles();

  const [clientName, setClientName] = useState('');

  // const [selectedContract, setSelectedContract] = useState('');

  // const handleChangeContract = event => {
  //   setSelectedContract(event.target.value);
  // };

  const [selectedStartDate, setSelectedStartDate] = useState(new Date('2020-01-01'));
  const [selectedEndDate, setSelectedEndDate] = useState(new Date('2020-01-01'));

  const handleStartDateChange = date => {
    setSelectedStartDate(date);
  };

  const handleEndDateChange = date => {
    setSelectedEndDate(date);
  };

  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <div className={classes.row}>
        <Typography
          className={classes.registerListItemTitle}
          color="textSecondary"
          gutterBottom
        >
          광고주명
        </Typography>

        <SearchInput
          className={classes.searchInput}
          placeholder=""
          value={clientName}
          onChange={e => setClientName(e.target.value)}
        />
        
        <Button
          color="primary"
          variant="contained"
          onClick={ () => onClickSearch(clientName, valueContract, selectedStartDate, selectedEndDate) }
        >
          조회
        </Button>
       
      </div>

      <div className={classes.row}>
        <Typography
          className={classes.registerListItemTitle}
          color="textSecondary"
          gutterBottom
        >
          계약 상태
        </Typography>

        <TextField
          className={classes.registerListItemInput}
          id="outlined-select-agency"
          select
          value={valueContract}
          onChange={onChangeContract}
          helperText=""
          //variant="outlined"
          margin="dense"
        >
          {contracts.map(option => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>

        </div>
        <div className={classes.row}>

        <Typography
          className={classes.registerListItemTitle}
          color="textSecondary"
          gutterBottom
        >
          등록일
        </Typography>

        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={krLocale}>
          <KeyboardDatePicker
            disableToolbar
            variant="inline"
            format="yyyy-MM-dd"
            margin="dense"
            id="reg-start-date-picker-inline"
            value={selectedStartDate}
            onChange={handleStartDateChange}
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
          />
          <Typography
            className={classes.registerListItemDateGap}
            color="textSecondary"
            gutterBottom
          >
            ~
          </Typography>
          <KeyboardDatePicker
            disableToolbar
            variant="inline"
            format="yyyy-MM-dd"
            margin="dense"
            id="reg-end-date-picker-inline"
            value={selectedEndDate}
            onChange={handleEndDateChange}
            KeyboardButtonProps={{
              'aria-label': 'change date',
            }}
          />
        </MuiPickersUtilsProvider>
      </div>
     
    </div>
  );
};

ClientToolbar.propTypes = {
  className: PropTypes.string
};

export default ClientToolbar;
